import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { formatPrice } from "../lib/api";
import { toast } from "sonner";

export default function ProductCard({ product, priority = false }) {
    const { toggleWishlist, inWishlist } = useCart();
    const liked = inWishlist(product.id);

    const handleLike = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const res = await toggleWishlist(product.id);
        if (!res.ok) toast.error(res.error || "Please sign in");
    };

    return (
        <Link
            to={`/product/${product.id}`}
            data-testid={`product-card-${product.id}`}
            className="group block"
        >
            <div className="relative aspect-[4/5] overflow-hidden bg-surface">
                <img
                    src={product.images?.[0]}
                    alt={product.name}
                    loading={priority ? "eager" : "lazy"}
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                {product.compare_at_price && product.compare_at_price > product.price && (
                    <span className="absolute left-3 top-3 bg-heart px-2 py-1 text-[10px] font-medium uppercase tracking-widest text-white">
                        Sale
                    </span>
                )}
                <button
                    onClick={handleLike}
                    data-testid={`wishlist-toggle-${product.id}`}
                    aria-label="Wishlist"
                    className={`absolute right-3 top-3 flex h-9 w-9 items-center justify-center bg-obsidian/70 backdrop-blur transition-colors ${
                        liked ? "text-heart" : "text-white/70 hover:text-heart"
                    }`}
                >
                    <Heart className={`h-4 w-4 ${liked ? "fill-heart" : ""}`} strokeWidth={1.4} />
                </button>
                <div className="absolute inset-x-0 bottom-0 translate-y-2 bg-gradient-to-t from-obsidian/95 to-transparent p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                    <span className="inline-block bg-gold px-4 py-2 text-[10px] uppercase tracking-[0.25em] text-obsidian">
                        View piece
                    </span>
                </div>
            </div>
            <div className="mt-4 flex items-start justify-between gap-2">
                <div className="min-w-0 flex-1">
                    <p className="font-display text-base leading-tight text-white sm:text-lg">{product.name}</p>
                    <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-white/40 sm:text-xs">
                        {product.category === "clothing"
                            ? "Atelier"
                            : product.category === "home"
                              ? "Maison"
                              : "Studio"}
                    </p>
                </div>
                <div className="flex-shrink-0 text-right">
                    <p className="text-sm text-gold">{formatPrice(product.price)}</p>
                    {product.compare_at_price && product.compare_at_price > product.price && (
                        <p className="text-[10px] text-white/30 line-through sm:text-xs">{formatPrice(product.compare_at_price)}</p>
                    )}
                </div>
            </div>
        </Link>
    );
}
